import { writable } from "svelte/store";

export const isNotSuspendedAudioContextStore = writable(false);
